import React, { Component } from 'react'

class Divisions extends Component {

  render() {

    let { title, divisions, extraPaddingBottom, extraPaddingTop } = this.props

    return (
      <section className={`divisions ${extraPaddingBottom ? 'divisions--extra-padding' : ''} ${extraPaddingTop ? 'divisions--extra-padding-top' : ''}`}>
        <div className='divisions__inner'>
          <h2 className='divisions__title' dangerouslySetInnerHTML={{ __html: title }} />
          { divisions && 
            <div className='divisions__items'>
              {divisions.map((el, i) => (
                <div className='divisions__item' key={i}>
                  <h4 dangerouslySetInnerHTML={{ __html: el.title }} />
                  <div dangerouslySetInnerHTML={{ __html: el.content }} />
                </div>
              ))}
            </div>
          }
        </div>
      </section>
    )
  }
}

export default Divisions
